import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Picture from '../models/Picture';

export interface ExifGeoLocationAttrs {
    picture: Picture
}

const IMAGES_ALREADY_LOADED: string[] = [];

export default class ExifGeoLocation implements ClassComponent<ExifGeoLocationAttrs> {
    showMap: boolean = false
    showMapTimeout: number = 0

    oninit(vnode: Vnode<ExifGeoLocationAttrs>): any {
        // When browsing back to an image we know we have loaded, don't wait
        if (IMAGES_ALREADY_LOADED.indexOf(JSON.stringify(vnode.attrs.picture.geo())) !== -1) {
            this.showMap = true;
        }
    }

    oncreate(vnode: Vnode<ExifGeoLocationAttrs>): any {
        if (this.showMap) {
            return;
        }

        // Don't render the map immediately, this will be more performant if the user is just quickly skipping through images
        this.showMapTimeout = setTimeout(() => {
            const geoKey = JSON.stringify(vnode.attrs.picture.geo());

            if (geoKey) {
                IMAGES_ALREADY_LOADED.push(geoKey);
            }

            this.showMap = true;
            m.redraw();
        }, 1000) as any;
    }

    onremove(): any {
        clearTimeout(this.showMapTimeout);
    }

    view(vnode: Vnode<ExifGeoLocationAttrs>) {
        const {picture} = vnode.attrs;

        const geo = picture.geo();
        const token = app.forum.attribute('cimaiseMapboxToken');

        if (!geo || !token) {
            return null;
        }

        const coordinates = geo.lng + ',' + geo.lat;
        const zoom = 13;

        return m('.CimaiseGeoSection', [
            m('.CimaiseSectionTitle', m('h3', 'Location')),
            this.showMap ? m('.CimaiseGeo', m('img', {
                src: 'https://api.mapbox.com/styles/v1/mapbox/light-v11/static/pin-s+000(' + coordinates + ')/' + coordinates + ',' + zoom + '/330x230?access_token=' + token,
                alt: 'Map',
            })) : LoadingIndicator.component(),
        ]);
    }
}
